export * from './lib/tag/tag.component';
